import type { SVGProps } from "react";

const base: SVGProps<SVGSVGElement> = {
  viewBox: "0 0 32 32",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
};

export function RetailIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...props}>
      <path d="M6 12l1.3-5h17.4l1.3 5" />
      <path d="M6.5 12v13a1 1 0 001 1h17a1 1 0 001-1V12" />
      <line x1="13" y1="26" x2="13" y2="18" />
      <line x1="19" y1="26" x2="19" y2="18" />
    </svg>
  );
}

export function ManufacturingIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...props}>
      <path d="M5 26V16l6 4v-4l6 4v-4l6 4v6z" />
      <line x1="5" y1="26" x2="27" y2="26" />
      <line x1="9" y1="16" x2="9" y2="10" />
      <circle cx="9" cy="8" r="1.6" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function RealEstateIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...props}>
      <path d="M6 15L16 6l10 9" />
      <path d="M8 14v12a1 1 0 001 1h14a1 1 0 001-1V14" />
      <line x1="13" y1="27" x2="13" y2="19" />
      <line x1="19" y1="27" x2="19" y2="19" />
      <line x1="13" y1="19" x2="19" y2="19" />
    </svg>
  );
}

export function HealthcareIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...props}>
      <rect x="5" y="5" width="22" height="22" rx="3" />
      <line x1="16" y1="11" x2="16" y2="21" />
      <line x1="11" y1="16" x2="21" y2="16" />
    </svg>
  );
}

export function EducationIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...props}>
      <path d="M4 11l12-5 12 5-12 5-12-5z" />
      <path d="M9 14v7c0 2 3 3.5 7 3.5s7-1.5 7-3.5v-7" />
      <line x1="27" y1="12" x2="27" y2="20" />
    </svg>
  );
}

export function HospitalityIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...props}>
      <path d="M5 22c0-6 4-10 11-10s11 4 11 10" />
      <line x1="4" y1="22" x2="28" y2="22" />
      <line x1="16" y1="12" x2="16" y2="7" />
      <circle cx="16" cy="5.5" r="1.3" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function AutomobileIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...props}>
      <path d="M6 20l2-7a2 2 0 012-1.4h12A2 2 0 0124 13l2 7" />
      <rect x="4.5" y="20" width="23" height="6" rx="2" />
      <circle cx="10.5" cy="26.5" r="2" />
      <circle cx="21.5" cy="26.5" r="2" />
    </svg>
  );
}

export function JewelleryIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...props}>
      <path d="M9 10h14l4 5-11 12L6 15z" />
      <path d="M13 10l-2 5 5 12 5-12-2-5" />
      <line x1="6" y1="15" x2="26" y2="15" />
    </svg>
  );
}

export function EventsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...props}>
      <rect x="6" y="7" width="20" height="20" rx="2" />
      <line x1="6" y1="13" x2="26" y2="13" />
      <line x1="11" y1="5" x2="11" y2="9" />
      <line x1="21" y1="5" x2="21" y2="9" />
      <circle cx="16" cy="20" r="3.4" />
    </svg>
  );
}

export function CorporateIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...props}>
      <rect x="9" y="4" width="14" height="23" rx="1" />
      <line x1="13" y1="9" x2="19" y2="9" />
      <line x1="13" y1="13" x2="19" y2="13" />
      <line x1="13" y1="17" x2="19" y2="17" />
      <line x1="6" y1="27" x2="26" y2="27" />
    </svg>
  );
}
